import { MoreDotsIcon } from '@tableau/icons/MoreDotsIcon';
import { FlyoutListMenuWidget, MenuButtonWidget, ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';

import { IPrivateConnectionInfo } from '../models/PrivateConnectModels';

export interface PrivateConnectActionMenuState {
    isOpen: boolean;
}

export interface PrivateConnectActionMenuProps {
    privateConnection: IPrivateConnectionInfo;
    server: SessionManagementService;
}

const exploreActionsMenuId = 'actions-menu-explorer-id';

const menuButtonDropdowStyle = style(
    { $nest: { '&&::after': { display: 'none' }, '&:disabled' : {borderColor: 'transparent !important'} } }
);

export const menuButtonStyle: React.CSSProperties = {
    borderColor: 'transparent', padding: 0, minWidth: 30
};

export class PrivateConnectActionMenu extends React.Component<PrivateConnectActionMenuProps, PrivateConnectActionMenuState> {
    private buttonElement: HTMLElement | null = null;

    public constructor(props: PrivateConnectActionMenuProps) {
        super(props);

        this.state = {
            isOpen: false,
        };
    }

    private setButtonRef = (ref: HTMLButtonElement | null): void => {
        this.buttonElement = ref;
    };

    private onSelect(label: string) {
        switch (label) {
            case Messages.privateConnect_copyUrl_label():
                navigator.clipboard.writeText(this.props.privateConnection?.dnsName ?? '').then(() => {
                    ToastWidget.show({
                        message: Messages.privateConnect_urlCopied_message(),
                        testId: 'private-connect-copy-success',
                        toastType: ToastType.Info
                    });
                });
              break;
          }
          this.setState({isOpen: false});
    }

    public render(): JSX.Element {
        return <>
            <MenuButtonWidget
                aria-controls={exploreActionsMenuId}
                isOpen={this.state.isOpen}
                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                ref={this.setButtonRef}
                testId='private-connect-actions-menu'
                density='low'
                className={menuButtonDropdowStyle}
                style={menuButtonStyle}
            >
                <MoreDotsIcon size={14}/>
            </MenuButtonWidget>
            {this.state.isOpen && <FlyoutListMenuWidget
                role='menu'
                anchorEl={this.buttonElement}
                allowAutoPosition
                id={exploreActionsMenuId}
                menuItemInfos={[
                    { displayValue: Messages.privateConnect_copyUrl_label(), value: Messages.privateConnect_copyUrl_label() },
                  ]}
                onSelect= {(value: string) => this.onSelect(value)}
                requestCloseAll={() => this.setState({ isOpen: false })}
                testId='private-connect-actions-menu-list'
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                toggleEl={this.buttonElement!}
            />}
        </>;
    }
}
